export type NullableString = string | null | undefined;

export const isEmptyString = (value: NullableString): boolean => {
  return !value;
};
